<template>
  <div>
    <WyneLoverTopNav active-app="lover" />
    <MatchMedia query="(max-width: 768px)" v-slot="{ matches }">
      <IndexMobile v-if="matches" />
      <IndexDesktop v-else />
    </MatchMedia>
  </div>
</template>

<script>
import { MatchMedia } from "vue-component-media-queries";
import Cookies from "js-cookie";

import WyneLoverTopNav from '@/components/WyneLover_TopNav.vue';

import IndexMobile from "@/components/Index_Mobile.vue";
import IndexDesktop from "@/components/Index_Desktop.vue";

export default {
  name: "Atlas",

  components: {
    MatchMedia,
    WyneLoverTopNav,
    IndexMobile,
    IndexDesktop
  },

  created() {
    const supportedLanguages = [
      "en", "fr", "de", "es", "it", "nl", "pt"
    ];

    let language = Cookies.get("wynelover.language");

    if (!supportedLanguages.includes(language)) {
      language = "en";
    }

    this.$store.commit("setLanguage", language);
  }
};
</script>